<template>
	<div>
		<el-dialog title="修改结果集模板" @closed="closed" :visible.sync="dialogVisible" @opened="openeds" width="90%"
		 append-to-body>
			<div>
				<el-table :data="tableData" tooltip-effect="dark" style="width: 100%;" highlight-current-row :header-cell-style="{'font-family':'MicrosoftYaHei','font-weight':'bold','font-size':'16px','padding': '5px 0','background':'#ffffff','color':'#262b33'}"
				 :cell-style="{'font-family':'MicrosoftYaHei','font-size':'16px','padding': '5px 0','color':'#4f5869'}">
					<!-- <el-table-column type="index" width="40">
					</el-table-column>
					<el-table-column sortable prop="TASKSTATENAME" align="center" label="执行状态" width="110" min-width="12%">
						<template slot-scope="scope">
							<div :class="scope.row.STATE|taskStateFormater">
							</div>
						</template>
					</el-table-column>
					<el-table-column sortable label="创建人" show-overflow-tooltip width="100">
						<template slot-scope="scope">
							<span href="#" v-html="Highlight(scope.row,'创建人',scope.row.CREATEUSERNAME)">
							</span>
						</template>
					</el-table-column>
					<el-table-column sortable label="任务名称" width="630" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-popover v-show="isPopover(scope.row)" placement="top-start" width="450" trigger="hover">
								<div>
									<el-row v-for="(item,index) in scope.row.MatchFields" :key="index">
										<el-col :span="5">{{ item.Name+':' }}</el-col>
										<el-col :span="19" v-html="item.Value"></el-col>
									</el-row>
								</div>
								<div slot="reference">
									<div class="taskName" v-html="Highlight(scope.row,'任务名',!scope.row.CONTENT?scope.row.TASKNAME:scope.row.TASKNAME+'-')">
									</div>
									<div class="taskContent" v-html="Highlight(scope.row,'任务详情',delHtmlTag(scope.row.CONTENT))">
									</div>
								</div>
							</el-popover>
							<div v-show="!isPopover(scope.row)">
								<div class="taskName" v-html="Highlight(scope.row,'任务名',!scope.row.CONTENT?scope.row.TASKNAME:scope.row.TASKNAME+'-')">
								</div>
								<div class="taskContent" v-html="Highlight(scope.row,'任务详情',delHtmlTag(scope.row.CONTENT))">
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column sortable prop="CREATETIME" label="创建时间" show-overflow-tooltip width="180">
						<template slot-scope="scope">
							{{scope.row.CREATETIME|timeFormater }}
						</template>
					</el-table-column>
					<el-table-column sortable label="执行人" show-overflow-tooltip width="100">
						<template slot-scope="scope">
							<a href="#" v-html="Highlight(scope.row,'执行人',scope.row.EXCUTEUSERNAME)">
							</a>
						</template>
					</el-table-column>
					<el-table-column sortable prop="FOCUSDEGREE" align="center" label="关注度" show-overflow-tooltip width="110">
						<template slot-scope="scope">
							<div :class="scope.row.FOCUSDEGREE|focusDegreeFormater">
							</div>
						</template>
					</el-table-column> -->
					<el-table-column v-for="(column, index) in columns" :key="index" :property="column.value" :label="column.text"
					 :width="column.width">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
								移除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		UpdateTemplate
	} from "@/api/modules/basicData/task";
	export default {
		data() {
			return {
				dialogVisible: false,
			}
		},
		mounted() {
			console.log(this.category,'判断类型')
		},
		props: {
			// columns: {
			// 	type: Array,
			// 	default: function() {
			// 		return [ // 列
			// 			{
			// 				text: "任务状态",
			// 				value: "TASKSTATENAME"
			// 			}, {
			// 				text: "任务名称",
			// 				value: "TASKNAME"
			// 			}, {
			// 				text: "创建人",
			// 				value: "CREATEUSERNAME"
			// 			}
			// 			// , {
			// 			// 	text: "创建时间",
			// 			// 	// value: "CREATETIME"
			// 			// 	value: `${"CREATETIME".replace("T", " ").substr(0, 19)}`
			// 			// },
			// 		]
			// 	}
			// }
		},
		filters: {
			focusDegreeFormater: function(val) {
				switch (val) {
					case 1:
						return 'guanzhu1';
					case 2:
						return 'guanzhu2';
					case 3:
						return 'guanzhu3';
					default:
						return 'noguanzhu';
				}
			},
			taskStateFormater: function(val) {
				switch (val) {
					case 0:
						return 'daijieshou';
					case 1:
						return 'zhixingzhong';
					case 2:
						return 'wancheng';
					case 3:
						return 'guanbi';
					case 4:
						return 'shenpizhong';
					case 5:
						return 'guaqizhong';
					case -1:
						return 'zuofei';
					default:
						return 'guanbi';
				}
			},
		},
		methods: {
			openeds() {
				console.log(this.columns, '模板类型')
			},
			amendAm() {
				this.$emit("amendAm")
			},
			deleteRow(index, rows) {
				console.log(this.tagItem, "tagItem");
				console.log(index, "index");
				// console.log(JSON.stringify(rows), "rows");

				let delArr = rows.splice(index, 1);
				let [del,...useless] = delArr;
				var taskIdArr = [],
					tagObj = {},
					content = '';
				rows.forEach((c) => {
					taskIdArr.push(c[this.rowId])
				})
				tagObj = this.tagItem;
				
				if(typeof (del[this.rowId]) === 'object'){
					//如果ID为对象
					content = taskIdArr.join(",")
					if(content){
						content = "["+content+"]";
					}
				}
				else{
					content = taskIdArr.join(",")
				}
				tagObj.CONTENT = content;
				console.log(tagObj, 'tagObj')
				UpdateTemplate(tagObj,this.category).then(res => {
					// console.log(res, "tagObjtagObjtagObj -----------res")
				})

			},
			closed() {
				this.$store.commit("getAllTemplate");
			},
			Highlight(row, title, FieldValue) { //高亮显示
				if (row.MatchFields) {
					let fieldRow = row.MatchFields.filter(p => p.Name === title);
					if (fieldRow.length > 0)
						// alert(row.MatchFields.filter(p => p.Name === 'TASKNAME').Value)
						return fieldRow[0].Value;
					else
						return FieldValue
				} else {
					return FieldValue;
				}
			},
			isPopover(row) {
				if (row.MatchFields) {
					if (row.MatchFields.length > 0) {
						return true
					} else {
						return false;
					}
				} else {
					return false;
				}
			},
		},
		computed: {
			tableData: function() {
				return this.$store.state.template.tableData;
			},
			tagItem: function() {
				return this.$store.state.template.tagItem;
			},
			columns: function() {
				return this.$store.state.template.columns;
			},
			category: function() {
				return this.$store.state.template.category;
			},
			rowId: function() {
				return this.$store.state.template.rowId;
			},
		}
	}
</script>

<style scoped>
	.taskContent {
		float: left;
		color: #929baa;
	}

	.taskName {
		font-weight: bold;
		float: left;
	}
</style>
